// production TEST API
export const serverBasePath = "https://international.azu.edu.eg/";
// Dev API
// export const serverBasePath = "http://149.102.143.225:9090/";

// export const serverBasePath_embassy = "http://149.102.143.225:9090/";
